import { createContext } from 'react';

const SidebarContext = createContext(void 0);

SidebarContext.displayName = 'context(sidebar)';

export default SidebarContext;